import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntitySupplier } from "../../entity/EntitySupplier";

export class DtoSuppliersGetReq extends EntitySupplier {
  public IsValid(): string[] {
    let res: string[] = new Array();
    //単項目チェック
    //--------------
    if (!commonRegx.isMatch(this.c_supplier_id!.toString(), "^\\d+$", commonRegx._stdOption)) {
      res.push("type error");
    }

    return res;
  }
}
